import React from 'react'
import { useTranslation } from 'react-i18next'
import {
	Box,
	Text
} from '@shopify/polaris'

const CreditItem = ({
	credit,
	index,
	totalCredits
}) => {
	const { t } = useTranslation()
	const isLastItem = index === totalCredits - 1

	return (
			<Box padding='2'>
				<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							padding: '8px 0',
							borderBottom: isLastItem ? 'none' : '1px solid #E3E3E3'
						}}
				>
					<Text variant='bodyMd'>{credit.name}</Text >
					<Text color='subdued'>
						{t("taxCorePages.dashboard.creditsCount", { count: credit.count })}
					</Text >
				</div >
			</Box >
	)
}

export default CreditItem

